import { Group, Text } from '@mantine/core';
import { t } from 'i18next';

import { StatusYear } from '../model/ProjectTypes';

interface StatusYearCardListProps {
  statusYearList: StatusYear[];
}

export function StatusYearCardList(props: StatusYearCardListProps) {
  const { statusYearList } = props;
  return (
    <Group gap="xs">
      {statusYearList.map((statusYear, index) => (
        <Group
          key={statusYear.id}
          mb="1px"
          gap="xs"
        >
          <Text size="sm">
            {statusYear.year} - {t(`projects.statusEnum.${statusYear.status}`)}
            {index !== statusYearList.length - 1 ? ',' : ''}
          </Text>
        </Group>
      ))}
    </Group>
  );
}
